import { render, staticRenderFns } from "./TableColumnInfo.vue?vue&type=template&id=bdc3972a&"
import script from "./TableColumnInfo.vue?vue&type=script&lang=js&"
export * from "./TableColumnInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports